import { CookieBanner } from "./types"

// We can set a cookie for a domain. If we set it for the top-level domain, it will be readable in any subdomain.
function setCookie(name: string, value: string, domain: string, days: number) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name + "=" + (value || "") + expires + "; path=/" + "; domain=" + domain;
}
function getCookie(name: string) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name: string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

// Functions to save some client state to keep preference and maintain some ID for consent management.
// We use localStorage by default unless we need to use cookies, in the case of cross domain feature.
export function getItem(key: string, cookieBanner: CookieBanner) {
  if (cookieBanner.enableCrossDomain) {
    return getCookie(key);
  } else {
    return localStorage.getItem(key);
  }
}
export function setItem(key: string, value: string, cookieBanner: CookieBanner) {
  if (cookieBanner.enableCrossDomain) {
    setCookie(key, value, cookieBanner.domainName, 360);
  } else {
    localStorage.setItem(key, value);
  }
}
export function removeItem(key: string, cookieBanner: CookieBanner) {
  if (cookieBanner.enableCrossDomain) {
    eraseCookie(key);
  } else {
    localStorage.removeItem(key);
  }
}

